import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";

const Footer = () => {
  return (
    <footer className="minimal-footer">
      <div className="footer-top">
        {/* Brand Section */}
        <div className="footer-brand">
          <h2>Lovely Cakes</h2>
        </div>

        {/* Navigation Links */}
        <div className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/products">Our Cakes</Link>
          <Link to="/aboutus">About Us</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* Social Links */}
        <div className="footer-social">
          <a
            href="https://www.instagram.com/lovelycakeswalsall"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>
          <a href="#pinterest" target="_blank" rel="noreferrer">
            TikTok
          </a>
          <a href="#facebook" target="_blank" rel="noreferrer">
            Facebook
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Lovely Cakes. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
